import TwoFactorContainer from "../../../../components/formsAndTable/forms/formLayout/twoFactor";

const TwoFactor = () => {
  return <TwoFactorContainer />;
};

export default TwoFactor;
